/* eslint react/jsx-key: off */

// import "babel-polyfill";
import React, { Fragment } from "react";
import { Admin, Resource, defaultI18nProvider } from "react-admin";
import { render } from "react-dom";
import authProvider from "./authProvider";
import dataProvider from "./dataProvider";
import { createMuiTheme } from "@material-ui/core/styles";

import customRoutes from "./customRoutes";

//---------------Regular CRUD Components---------------------
import UserComponents from './views/user'
import TradeRevAutoProxyComponents from './views/tradeRev-auto-proxy'
import CarComponents from './views/car'
import { ExchangeRateProvider } from './context/ExchangeRateContext';


import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Login from './views/Login'
import MyLayout from './layout/MyLayout'
import { put, takeEvery, } from 'redux-saga/effects'

import {
  REGISTER_RESOURCE, // React-admin 3.5.0 
  setSidebarVisibility,
} from 'react-admin'


function* closeSidebar(action) {
  try {
    if (action.payload) {
      yield put(setSidebarVisibility(false))
    }
  } catch (error) {
    console.log('closeSidebar:', error)
  }
}

function* closeSidebarSaga() {
  yield takeEvery(REGISTER_RESOURCE, closeSidebar)
}

render(
  <Fragment>
    <ToastContainer newestOnTop />
    <ExchangeRateProvider>
      <Admin
        loginPage={Login}
        authProvider={authProvider}
        dataProvider={dataProvider}
        i18nProvider={defaultI18nProvider}
        title="TradeRev Auto Proxy"
        locale="en"
        layout={MyLayout}
        customRoutes={customRoutes}
        customSagas={[closeSidebarSaga]}
      >
        {permissions => {
          let permissionsArr = permissions.split(",");
          return [
            // <Resource {...CarComponents} />,
            permissionsArr.includes("web_app_traderev_auto_proxy") ? (<Resource {...TradeRevAutoProxyComponents} />) : null,
            permissionsArr.includes("web_app_user") ? (<Resource {...UserComponents} />) : null
          ];
        }}
      </Admin>
    </ExchangeRateProvider>
  </Fragment>,
  document.getElementById("root")
);
